import { create } from "zustand";

const playerResourceQuantityStore = create((set, get) => ({
  playerResourceQuantitys: {}, // Lưu trữ tất cả các player và config của họ

  // Cập nhật một config trong một player cụ thể
  updateSingleResourceQuantity: (playerId, resourceId, value) => {
    if (value === get().playerResourceQuantitys[playerId][resourceId]) {
      return;
    }
    set((state) => (
      {
        playerResourceQuantitys: {
          ...state.playerResourceQuantitys,
          [playerId]: {
            ...state.playerResourceQuantitys[playerId], // Giữ lại các config cũ
            [resourceId]: value, // Cập nhật config cụ thể
          },
        },
      }))
  },

  // Cập nhật toàn bộ config của một player
  updatePlayerResourceQuantity: (playerId, newResource) =>
    set((state) => ({
      playerResourceQuantitys: {
        ...state.playerResourceQuantitys,
        [playerId]: newResource, // Cập nhật toàn bộ config của player
      },
    })),

  // Cập nhật nhiều player cùng lúc
  updateMultiplePlayersQuantity: (newResources) =>
    set((state) => ({
      playerResourceQuantitys: {
        ...state.playerResourceQuantitys,
        ...newResources, // Merge với configs hiện tại
      },
    })),
}));

export default playerResourceQuantityStore;
